import Splide from '@splidejs/splide';

let quizz = null
let slideQuizz = null
let questionActive = 1
let pucesNav = null
export const init = function (element) {

    quizz = element

    slideQuizz = new Splide( '.quizz__conteneur', {
        drag   : false,
   } ).mount()
   .on( 'move resize', updateHeight )
   .on( 'moved', function (e) { // Vérifier si la question active à été répondu
    var slideActive = e+1
    if (slideActive>=questionActive)  desactiveNext()
    });
   
   updateHeight();

   // Stocker les puces pour les activer ou les désactiver
   pucesNav = document.querySelectorAll('.splide__pagination li')

   
   // Désactiver la flèche
   desactiveNext()

   // Evenements
   const propositions = document.querySelectorAll('.question__proposition')
   propositions.forEach(element => {
    element.addEventListener('click', function(e){
        var choix = e.target
        var question = choix.closest(".question") 

        if ( !question.classList.contains('is-repondu')) {
            choix.classList.add('is-choix')
            question.classList.add('is-repondu')
            question.classList.add('is-resultat'+choix.dataset.reponse )
            questionActive++
            activeNext()
        }
    })
   });

   slideQuizz
}

let updateHeight = () => {
    let slide = slideQuizz.Components.Slides.getAt( slideQuizz.index ).slide;
    slide.parentElement.style.height = slide.offsetHeight + 'px';
  };

const activeNext = function() {
    quizz.querySelector('.splide__arrow--next').disabled = false;
    pucesNav.forEach((element,index) => {
        if ((index) >=questionActive)  {
            element.querySelector('button').disabled = true;
        }
        else element.querySelector('button').disabled = false;
    });
}

const desactiveNext = function() {
    quizz.querySelector('.splide__arrow--next').disabled = true;
    pucesNav.forEach((element,index) => {
        if ((index) >=questionActive)  {
            element.querySelector('button').disabled = true;
        }
        else element.querySelector('button').disabled = false;
    });
}